import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function CashPack(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [rows, setRows] = useState([]);
    const [oppackData, setoppackData] = useState([]);
    const [rows1, setRows1] = useState([]);
    const [ippackData, setippackData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // Fetch OP and IP data when date changes or at interval
    useEffect(() => {
        fetchData();
        fetchIpData();
        const intervalId = setInterval(fetchData, 12000); // refresh OP data every 15 seconds
        return () => clearInterval(intervalId);
    }, [selectedDate]);
    // Format OP data for DataGrid
    useEffect(() => {
        if (oppackData.length > 0) {
            setRows(oppackData.map(row => ({...row, id: row.id})));
        }
    }, [oppackData]);
    // Format IP data for DataGrid
    useEffect(() => {
        if (ippackData.length > 0) {
            setRows1(ippackData.map(row => ({...row, id: row.id})));
        }
    }, [ippackData]);
    // Fetch OP pack payments
    function fetchData() {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(`${baseUrl}oppack-pay-view/${formattedDate}/`)
            .then(response => {
                setoppackData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    // Fetch IP pack payments
    function fetchIpData() {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(`${baseUrl}ippack-pay-view/${formattedDate}/`)
            .then(response => {
                setippackData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    // Columns for OP packs
    const columns = [
        {field: 'id', headerName: 'Id', width: 50},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {field: 'pack_test', headerName: 'Test Name', width: 400},
        {field: 'addedby', headerName: 'Added by', width: 100},
        {field: 'pack_amount', headerName: 'Amount', width: 100},
        {field: 'pack_tot', headerName: 'Total', width: 100},
        {
            field: 'action',
            headerName: 'Action',
            width: 100,
            renderCell: (params) => (
                <Link to={`/op-pack-pay/${params.row.id}`} className="btn btn-success">
                    Pay
                </Link>
            ),
        },
    ];
    // Columns for IP packs
    const columns1 = [
        {field: 'id', headerName: 'Id', width: 50},
        {field: 'ip__ip_id', headerName: 'Patient IP ID', width: 100},
        {field: 'ip__pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'ip__pat__patient', headerName: 'Patient', width: 200},
        {field: 'pack_test', headerName: 'Test Name', width: 400},
        {field: 'addedby', headerName: 'Added by', width: 100},
        {field: 'pack_amount', headerName: 'Amount', width: 100},
        {field: 'pack_tot', headerName: 'Total', width: 100},
        {
            field: 'action',
            headerName: 'Action',
            width: 100,
            renderCell: (params) => (
                <Link to={`/ip-pack-pay/${params.row.id}`} className="btn btn-success">
                    Pay
                </Link>
            ),
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>


            <div style={{height: "100%", width: "100%"}} className="mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-stethoscope" style={{color: 'red'}}></i> OP Cashier Package
                </h3>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    autoHeight
                    slots={{toolbar: GridToolbar}}
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                />
            </div>


            <div style={{height: "100%", width: "100%"}} className="mt-5">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-stethoscope" style={{color: 'red'}}></i> IP Cashier Package
                </h3>
                <DataGrid
                    rows={rows1}
                    columns={columns1}
                    pageSize={10}
                    autoHeight
                    slots={{toolbar: GridToolbar}}
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                />
            </div>

        </section>
    );
}
export default CashPack;